import React from 'react';

const ProgressIndicator = ({ 
  title = 'Overall Progress',
  current = 0,
  total = 100,
  showDetails = true,
  className = ''
}) => {
  const percentage = total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <div className={`progress-indicator ${className}`}>
      <div className="progress-header">
        <span className="progress-title">{title}</span>
        <span className="progress-percentage">{percentage}%</span>
      </div>

      <div className="progress-bar-container">
        <div 
          className="progress-bar-fill"
          style={{ width: `${percentage}%` }}
          role="progressbar"
          aria-valuenow={percentage}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>

      {showDetails && (
        <div className="progress-details">
          <span>{current} completed</span>
          <span>{total - current} remaining</span>
        </div>
      )}
    </div>
  );
};

export default ProgressIndicator;